import { Formik } from 'formik'
import * as Yup from 'yup'
import React, { useState, useEffect, useCallback } from 'react'
import {
  BoxContainer,
  Button,
  Loading,
  Typography
} from '../../../../components'
import { Form, FormBody } from '../../../../components/Form/styles'
import Textarea from '../../../../components/Form/Textarea'
import { Container, ContainerButton } from './styles'
import { useQuery } from 'react-query'
import ecbrApi from '../../../../services/ecbrApi'
import { ConfigurationsKeys } from '../../../../constants/adminEcbrConfigurations'
import { errorResponseStatusHandler } from '../../../../utils/handlers/errorResponseStatusHandler'
import { useModal } from '../../../../hooks/useModal'
import { AlertModal } from '../../../../modals/AlertModal'
import { ModalBodyContainer } from '../../../../modals/styles'
import ErrorMessage from '../../../../components/Form/ErrorMessage'

const initialValues = {
  terms: ''
}

const formSchema = Yup.object().shape({
  terms: Yup.string().required('Campo obrigatório')
})

const TermAndConditionScreen = () => {
  const [error, setError] = useState('')
  const [saveBtnText, setSaveBtnText] = useState('Salvar Alterações')
  const [alertModal, openAlertModal] = useModal(AlertModal)

  const openAlert = useCallback(
    () =>
      openAlertModal({
        title: `Dados salvos!`,
        body: (
          <ModalBodyContainer>
            <Typography type="text" color="#7D7987">
              As configurações do termo de aceite foram salvos com sucesso.
            </Typography>
          </ModalBodyContainer>
        )
      }),
    [openAlertModal]
  )

  const {
    data: config,
    isSuccess: _,
    isLoading,
    refetch
  } = useQuery(
    'configs_terms',
    async () => {
      const { data } = await ecbrApi.configs.getByKey(ConfigurationsKeys.TERMS)
      return data
    },
    {
      onSuccess: () => {
        setError('')
      },
      onError: (err) => {
        if (err.response.status === 404) return
        setError('Não foi possível carregar os dados')
      },
      retry: false,
      refetchInterval: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false
    }
  )

  useEffect(() => {
    refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = async ({ terms }, { setSubmitting }) => {
    try {
      setSaveBtnText('Enviando...')
      setSubmitting(true)

      const formDataConfig = {
        key: ConfigurationsKeys.TERMS,
        value: terms
      }

      if (config) {
        const { id } = config
        await ecbrApi.configs.update(id, formDataConfig)
      } else {
        await ecbrApi.configs.create(formDataConfig)
      }
      setSubmitting(false)
      refetch()
    } catch (err) {
      errorResponseStatusHandler(err, setError)
    } finally {
      setSubmitting(false)
      setSaveBtnText('Salvar Alterações')
      openAlert()
    }
  }

  return (
    <BoxContainer>
      {alertModal}
      {isLoading && <Loading />}
      {!isLoading && (
        <Formik
          initialValues={config ? { terms: config.value } : initialValues}
          validationSchema={formSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form maxWidth="100%" margin="0">
              <FormBody type="flex" justifyContent="space-between" flexRow>
                <Container>
                  <Textarea
                    type="textarea"
                    name="terms"
                    label="Editar termos de aceite"
                  />
                  <ContainerButton>
                    <Button
                      text={saveBtnText}
                      type="submit"
                      variant="primary"
                      width="180px"
                      disabled={isSubmitting}
                    />
                  </ContainerButton>
                </Container>
              </FormBody>
            </Form>
          )}
        </Formik>
      )}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </BoxContainer>
  )
}

export default TermAndConditionScreen
